"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
function SubmitButton({ variant, size, shape, role, href, disabled, color, className, active, loading = false, children, dataTestID, }) {
    return ((0, jsx_runtime_1.jsx)(react_1.CButton, { type: 'submit', variant: variant, size: size, shape: shape, role: role, href: href, disabled: disabled || loading, color: color, className: className, active: active, "data-testid": dataTestID, children: loading ? (0, jsx_runtime_1.jsx)(react_1.CSpinner, { "data-testid": "submit-spinner" }) : children }));
}
exports.default = SubmitButton;
